import React from 'react';
import Papa from 'papaparse';

import localText from '../config/data/localization/localtext.csv';

// csv 파일 가져와서 파싱
// async function getCSV() {
//     const response = await fetch(localText);
//     const reader = await response.body.getReader()
//     const result = await reader.read() // raw array
//     const decoder = await new TextDecoder('euc-kr')
//     const csv = await decoder.decode(result.value) // the csv text
//     const results = await Papa.parse(csv, { header: true }) // object with { data, errors, meta }
//     const row = await results.data // array of objects
//     const tmpJsonArray = await makeObject(row);
//     Mki18n(tmpJsonArray);
//     return tmpJsonArray;
// }

// csv파일은 무조건 utf-8로 저장 필요. 참조 : https://becho.tistory.com/307
const loadCustomer = async () => {
  try {
    const response = await fetch(localText);
    if (!response.ok) throw new Error(response);
    const csv = await response.text();
    var results = Papa.parse(csv, {
      header: true,
    });
    const row = results.data;
    const tmpJsonArray = await makeObject(row);
    return tmpJsonArray;
  } catch (error) {
    console.error(error);
  }
};
export default loadCustomer;

function makeObject(objectArray) {
  // 오브젝트를 해체해서 값이 배열인 json으로 재생성
  let tmpArray = {};
  for (let i = 0; i < objectArray.length; i++) {
    const value = objectArray[i];
    if (value.code === '') {
      continue;
    }
    if (i === 0) {
      for (const res in value) {
        tmpArray[res] = [];
      }
    }
    for (const res in value) {
      tmpArray[res][i] = value[res];
    }
  }
  // 코드만 따로 뺌
  const codeArray = tmpArray.code;
  // 결과가 들어갈 json Object
  let resultObj = {};
  for (const value in tmpArray) {
    if (value !== 'code') {
      const elementArray = [...tmpArray[value]];
      let tempObj = {};
      for (let i = 0; i < elementArray.length; i++) {
        const code = codeArray[i];
        const element = elementArray[i];
        tempObj[code] = element;
      }
      resultObj[value] = {
        translation: tempObj,
      };
    }
  }
  return resultObj;
}

// function GetDataInCSV() {
//     console.log("GetDataInCSV");
//     const [csvData, setCSVData] = React.useState([]);

//     React.useEffect(() => {
//         async function getData() {
//             const response = await fetch(localText);
//             const reader = response.body.getReader()
//             const result = await reader.read() // raw array
//             const decoder = new TextDecoder('euc-kr')
//             const csv = decoder.decode(result.value) // the csv text
//             const results = Papa.parse(csv, { header: true }) // object with { data, errors, meta }
//             // 기본적으로 생성된 데이터
//             const row = results.data // array of objects
//             const tmpJsonArray = makeObject(row);
//             Mki18n(tmpJsonArray);
//             setCSVData("true");
//         }

//         function makeObject(objectArray) {
//             // 오브젝트를 해체해서 값이 배열인 json으로 재생성
//             let tmpArray = {};
//             for (let i = 0; i < objectArray.length; i++) {
//                 const value = objectArray[i];
//                 if (value.code === '') {
//                     continue;
//                 }
//                 if (i === 0) {
//                     for (const res in value) {
//                         tmpArray[res] = [];
//                     }
//                 }
//                 for (const res in value) {
//                     tmpArray[res][i] = value[res];
//                 }
//             }
//             // 코드만 따로 뺌
//             const codeArray = tmpArray.code;
//             // 결과가 들어갈 json Object
//             let resultObj = {};
//             for (const value in tmpArray) {
//                 if (value !== 'code') {
//                     const elementArray = [...tmpArray[value]];
//                     let tempObj = {};
//                     for (let i = 0; i < elementArray.length; i++) {
//                         const code = codeArray[i];
//                         const element = elementArray[i];
//                         tempObj[code] = element;
//                     }
//                     resultObj[value] = {
//                         'translation': tempObj
//                     }
//                 }
//             }
//             return resultObj;
//         }
//         getData()
//         return () => {
//             getData()
//         }
//     }, [localText]) // [] means just do this once, after initial render
//     // console.log("set Rows : ", rows);

//     // Mki18n(rows);
//     console.log("csvData : ", csvData);
//     return csvData;

// }
